import { IDENTIFY_IBAN, IDENTIFY_VIDEO_CALL, IDENTIFY_TRANSFER } from 'constants/actionTypes';

const identifyIban = (iban, identityIban, userProfile, ibanOnline, polling) => ({
    type: IDENTIFY_IBAN,
    iban,
    identityIban,
    userProfile,
    ibanOnline,
    polling,
});

const identifyTransfer = (userProfile, docNumberEncrypted) => ({
    type: IDENTIFY_TRANSFER,
    userProfile,
    docNumberEncrypted,
});

const identifyVideo = ({ date, videoCallType, urlCallType, language, investmentType, acceptedText }) => ({
    type: IDENTIFY_VIDEO_CALL,
    videoCallType,
    date,
    language,
    urlCallType,
    investmentType,
    acceptedText,
});

export default {
    identifyIban,
    identifyVideo,
    identifyTransfer,
};
